import i18n from "@/plugins/vue-i18n";
import store from "@/store";
import { hasUserPermission } from "@/utils/hasUserPermission";

const Orders = () => import(/* webpackChunkName: "orders" */ "@/views/orders/index");

const OrderList = () => import("@/views/orders/order/index.vue");
const DraftList = () => import("@/views/orders/draft/index.vue");

const OrdersDetails = () => import(/* webpackChunkName: "orders" */ "@/views/orders/order/details");

const OrdersDraftDetails = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/draft/details");

const OrdersNotificationsSettings = () => import("@/views/orders/settings/index.vue");
const OrdersAnalytics = () => import("@/views/orders/analytics/index.vue");
const OrdersAnalyticsSales = () => import("@/views/orders/analytics/tabs/SalesTab.vue");
const OrdersAnalyticsGoods = () => import("@/views/orders/analytics/tabs/GoodsTab.vue");

export const ordersAnalyticsChildren = [
  {
    path: "sales",
    name: "OrdersAnalyticsSales",
    component: OrdersAnalyticsSales,
    meta: {
      title: i18n.t("title.orders.analytics"),
      labelKey: "page.orders.sales",
      permission: "order.analytics_sales",
    },
  },
  {
    path: "goods",
    name: "OrdersAnalyticsGoods",
    component: OrdersAnalyticsGoods,
    meta: {
      title: i18n.t("title.orders.analytics"),
      labelKey: "page.orders.goods",
      permission: "order.analytics_products",
    },
  },
];

const resolveOrdersAnalyticsRedirect = (to) => {
  const getPermission = store.getters["user/getPermission"];
  const tab = ordersAnalyticsChildren.find((child) =>
    hasUserPermission(getPermission, child.meta?.permission)
  );

  if (!tab) {
    return { name: "NotFound" };
  }

  return {
    name: tab.name,
    query: to.query,
    hash: to.hash,
  };
};

const order = [
  {
    path: "/orders",
    component: Orders,
    children: [
      {
        path: "/orders",
        name: "Orders",
        component: OrderList,
        meta: {
          title: i18n.t("title.orders._"),
        },
      },
      {
        path: "drafts",
        name: "Drafts",
        component: DraftList,
        meta: {
          title: i18n.t("title.orders.drafts"),
        },
      },
    ],
  },
  {
    path: "/orders/settings",
    name: "OrdersNotificationsSettings",
    component: OrdersNotificationsSettings,
    meta: {
      title: i18n.t("title.fleaMarket.settingsModal"),
    },
  },
  {
    path: "/analytics",
    name: "OrdersAnalytics",
    component: OrdersAnalytics,
    redirect: resolveOrdersAnalyticsRedirect,
    children: ordersAnalyticsChildren,
  },
  {
    path: "/orders/:id",
    name: "OrdersDetails",
    component: OrdersDetails,
    meta: {
      title: i18n.t("title.orders._"),
    },
  },
  {
    path: "/orders/draft/:id",
    name: "OrdersDraftDetails",
    component: OrdersDraftDetails,
    meta: {
      title: i18n.t("title.orders.drafts"),
    },
  },
];

export default order;
